import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

interface StepLabel {
  step: number;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-progress-bar',
  imports: [CommonModule],
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  readonly currentStep = input<number>(1);
  readonly totalSteps = input<number>(6);

  // Labels pour le flux d'onboarding (6 étapes - catalogue et config produits fusionnés)
  private onboardingSteps: StepLabel[] = [
    { step: 1, label: 'Type de marchand', icon: '🧑‍🍳' },
    { step: 2, label: 'Activité principale', icon: '📋' },
    { step: 3, label: 'Localisation', icon: '📍' },
    { step: 4, label: 'Contexte', icon: '📊' },
    { step: 5, label: 'Mes produits', icon: '📦' },
    { step: 6, label: "C'est prêt !", icon: '✅' },
  ];

  get steps(): StepLabel[] {
    return this.onboardingSteps;
  }

  get progress(): number {
    return (this.currentStep() / this.totalSteps()) * 100;
  }

  isStepCompleted(step: number): boolean {
    return step < this.currentStep();
  }

  isStepCurrent(step: number): boolean {
    return step === this.currentStep();
  }

  isStepUpcoming(step: number): boolean {
    return step > this.currentStep();
  }
}
